import { render, staticRenderFns } from "./rindex.vue?vue&type=template&id=475ceae7&scoped=true"
import script from "./rindex.vue?vue&type=script&lang=js"
export * from "./rindex.vue?vue&type=script&lang=js"
import style0 from "./rindex.vue?vue&type=style&index=0&id=475ceae7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475ceae7",
  null
  
)

export default component.exports